import { Outlet } from "react-router-dom";
import Footer from "../Sections/Footer";
import Header from "../Sections/Header";
//css
import '../assets/css/all.min.css'
// import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import '../assets/css/bootstrap-rtl.min.css'
import '../assets/css/main.css'
import '../assets/css/responsive.css'

export default function MainLayout() {
    return(
        <div className="theme2">
            <Header/>
            <Outlet />
            <Footer/>
        </div>
    )
}